import Swiper, { Autoplay } from "swiper";

let swiperAboutLinks;

const swiperParent = document.querySelector(".values-carousel .swiper-swiper");
if (swiperParent) {
  const swiperWrapper = document.querySelector(".values-carousel .swiper-swiper-wrapper");
  const swiperItems = document.querySelectorAll(".values-carousel .swiper-swiper-slide");
  let screenWidth;

  function initSwiper() {
    screenWidth = window.innerWidth;
    if (screenWidth < 1024 && swiperAboutLinks === undefined) {
      swiperParent.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperItems.forEach((e) => e.classList.add("swiper-slide"));

      swiperAboutLinks = new Swiper(".values-carousel .swiper", {
        modules: [Autoplay],
        touchRatio: 0.2,
        slidesPerView: 1.35,
        spaceBetween: 20,
        freeMode: true,
        autoplay: {
          delay: 3000,
        },
      });
    } else if (screenWidth >= 1024 && swiperAboutLinks !== undefined) {
      swiperAboutLinks.destroy();
      swiperAboutLinks = undefined;
      swiperParent.classList.remove("swiper");
      swiperWrapper.removeAttribute("style");
      swiperWrapper.classList.remove("swiper-wrapper");

      swiperItems.forEach((e) => e.classList.remove("swiper-slide"));
    } else if (screenWidth >= 1024) {
      const lis = Array.prototype.slice.call(swiperParent.querySelectorAll(".item"));
      const lis_count = lis.length;
      const active_li_index = 0;

      lis[0].classList.add("swiper-slide-active");
    }
  }

  initSwiper();

  window.addEventListener(
    "resize",
    function (event) {
      initSwiper();
    },
    true
  );
}
